import React from 'react'
import bannerimg from "../../Assets/Banner/banner.jpg"
import "./Banner.css"

const Banner = () => {

    return (
        <>
            <div className="banner">
                <div className="banner-image">
                    <img src={bannerimg} alt="DLF" />
                </div>
                <div className="banner-stick">
                    <div className="banner-stick-box">
                        <span>New Launch</span>
                        <h2>Eden Wave City</h2>
                        <h5>At NH 24, Ghazaibad</h5>
                        <h5>Experience Modern Living at Eden Wave City: Your Dream Home Awaits</h5>
                        <p>Premium 3 BHK Residence | Price Starts <span> ₹ 1.48 Cr*</span> </p>
                        <p>Under Construction :<strong> Jun ‘29 possession</strong>

                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Banner
